// import moment from 'moment';
import * as echarts from 'echarts/core';
import { LineSeriesOption } from 'echarts/charts';
import { TooltipComponentOption, GridComponentOption } from 'echarts/components';
import ChartBubble from '@intelligence/components/ChartBubble';

type StackedAreaChartOption = echarts.ComposeOption<LineSeriesOption | TooltipComponentOption | GridComponentOption>;

const STACKED_AREA_STYLE: LineSeriesOption['areaStyle'] = {
  color: {
    type: 'linear',
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      {
        offset: 0,
        color: '#9BB5F2', // 0% 处的颜色
      },
      {
        offset: 1,
        color: '#fff', // 100% 处的颜色
      },
    ],
    global: false, // 缺省为 false
  },
};

export const STACKED_AREA_CHART_OPTION: StackedAreaChartOption = {
  tooltip: {
    trigger: 'axis',
    backgroundColor: 'rgba(255, 255, 255, 0)',
    padding: 0,
    borderWidth: 0,
    axisPointer: {
      type: 'line',
    },
    formatter: (params: any) => {
      const paramsTemp = [...params];
      paramsTemp[0].seriesName = 'Headcount';
      return ChartBubble({
        chartType: 'line',
        dateType: 'Month',
        headerLeftTitle: '-',
        headerRightTitle: '',
        data: paramsTemp,
        topChartsType: 'store_rank_more_line',
      });
    },
  },

  grid: {
    bottom: '0px',
    top: '15px',
    right: '5px',
    left: '40px',
    containLabel: true,
  },
  xAxis: {
    type: 'category',
    // @ts-ignore
    boundaryGap: false,
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      interval: 0,
      showMinLabel: true,
      showMaxLabel: true,
      fontSize: 12,
      align: 'center',
      color: '#BBBBBB',
    },
    // @ts-ignore
    splitNumber: 7,
    data: [],
  },
  yAxis: {
    type: 'value',
    show: true,
    position: 'right',
    splitLine: {
      // 网格线
      show: false,
    },
    splitNumber: 3,
    max: 'dataMax',
    axisLabel: {
      padding: [0, 0, 0, 4],
      fontSize: '12',
      color: '#BBBBBB',
    },
  },
  series: [
    {
      type: 'line',
      name: 'currentHeadcount',
      symbol: /* 'emptyCircle' */ 'circle',
      symbolSize: 6,
      lineStyle: {
        width: 2,
      },
      itemStyle: {
        color: '#376AE7',
        borderType: 'solid',
        // borderColor: '#fff',
        borderWidth: 0,
      },
      areaStyle: STACKED_AREA_STYLE,
      connectNulls: false,
      data: [],
    },
  ],
};
